import { Select, Typography } from 'seagull';
import { MenuItem } from 'seagull/components/MenuItem';
import { netTermsOptions } from "../../constants";
import pluralize from "../../utils/pluralize";
import { defaultWidth } from "../agreement-controllers/constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const NetTermsDropdown = _ref => {
  let {
    netTerms,
    onChange: _onChange,
    isReadOnly,
    testId,
    dropdownWidth = defaultWidth
  } = _ref;
  const getDisplayValue = numDays => numDays === 0 ? 'Upon receipt of invoice' : pluralize('day', numDays, true);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Typography, {
      as: "p",
      children: "Set the number of days until the payment is due"
    }), /*#__PURE__*/_jsx(Select, {
      collapseHelperText: false,
      style: {
        marginBlockStart: 8
      },
      disabled: isReadOnly,
      value: netTerms,
      isSelected: (itemValue, currentValue) => +itemValue === +currentValue,
      displayValue: getDisplayValue(netTerms),
      onChange: e => {
        _onChange(+e.target.value);
      },
      testId: testId,
      width: dropdownWidth,
      menuMaxHeight: 200,
      children: netTermsOptions.map((numOfDays, idx) => {
        const value = numOfDays.toString();
        return /*#__PURE__*/_jsx(MenuItem, {
          value: value,
          testId: "".concat(testId, "-option-").concat(idx),
          children: getDisplayValue(numOfDays)
        }, value);
      })
    })]
  });
};
export default NetTermsDropdown;